class EditionsViewer
{
    root: HTMLElement
    charsInPage: number
    bail_on_incomplete_paragraphs: boolean // TODO: this should be temporary

    private _paragraphs: NodeListOf<HTMLElement>

    private _notes: object // per note type
    private _eventListeners: object

    // Opportunity to emit a footnotes container must be kept as state because
    // footnotes in tables must only be collected and printed later, underneath.
    private _pageBreak: boolean;
    private _sectionEnds: boolean;

    private _attrsAndClasses = {
        lemmaPart: {
            counterpartsAttr: 'belongsTo',
            counterpartsHoverClass: 'lemma-hover',
        },
        note: {
            counterpartsAttr: 'lemmaParts',
            counterpartsHoverClass: 'note-hover',
        },
    }

    // NOPE, too early: constructor()
    setup(config: {
        root?: HTMLElement;
        chars_in_page: number;
        bail_on_incomplete_paragraphs?: boolean;
    })
    {
        this.root = config.root;
        this.charsInPage = config.chars_in_page;
        this.bail_on_incomplete_paragraphs = config.bail_on_incomplete_paragraphs;

        this._paragraphs = null;
        this._notes = {};

        this._pageBreak = false;
        this._sectionEnds = false;

        this._eventListeners = {
            'mouseover': {},
            'mouseout': {},
        };

        console.log(this.root, this.charsInPage);
    }

    getNoteHtml(note: HTMLElement): string
    {
        return note.dataset.bsTitle;
    }

    createFootnotesInWholeDocument()
    {
        console.log(
            `TODO: create and populate footnote “containers” behind paragraphs ` +
            `every ${this.charsInPage} chars in`, this.root);

        //  XXX: in other words, reimplement collect_notes_in_footnote_containers

        // p, h2, h3
        // DONE: make this an instance member and extract the loop body into
        //       a method to keep the loop short
        this._paragraphs = this.root.querySelectorAll(
            '[data-paragraph-number], td');

        if (this.bail_on_incomplete_paragraphs && this._bailOnIncompleteParagraph())
            return false;

        for (let i = 0; i < this._paragraphs.length; i++) {
            const paragraph = this._paragraphs[i];

            if (paragraph.classList.contains('footnotes-rendered')) // (if any)
                continue;

            const ret = this.createFootnotesInParagraph(i, paragraph);

            if (ret)
                paragraph.classList.add('footnotes-rendered'); // (if any)
        }
    }

    _bailOnIncompleteParagraph()
    {
        for (let i = 0; i < this._paragraphs.length; i++) {
            const paragraph = this._paragraphs[i];

            let complete = false;

            for (let flag of ['completed-paragraph']) {
                if (paragraph.classList.contains(flag)) {
                    complete = true;
                    break;
                }
            }

            if (complete)
                continue;

            for (let flag of ['incomplete-paragraph']) {
                if (paragraph.classList.contains(flag)) {
                    console.log('bailing on an incomplete paragraph', paragraph);
                    return true;
                }
            }
        }

        return false;
    }

    _nextParagraphInfo(i: number, paragraph: HTMLElement)
    {
        const nextParagraphIndex = i + 1;

        // We’re the last paragraph, there is none further.
        if (nextParagraphIndex >= this._paragraphs.length) {
            return {
                nextParagraph: null,
                charsPassedNext: 0,
            }
        }

        // We’re not the last paragraph yet so we can access the next paragraph
        // and the property we need.

        // nextParagraphIndex < this._paragraphs.length
        const nextParagraph: HTMLElement = this._paragraphs[nextParagraphIndex];

        const charsPassedNext = Number.parseInt(
            nextParagraph.dataset.charsPassed);

        return {
            nextParagraph,
            charsPassedNext,
        };
    }

    createFootnotesInParagraph(i: number, paragraph: HTMLElement): boolean
    {
        if (this._skipTableCellWithParagraphs(paragraph))
            return true;

        const chars = Number.parseInt(
            paragraph.dataset.chars); // data-chars
        const charsPassed = Number.parseInt(
            paragraph.dataset.charsPassed); // data-chars-passed
        const charsBefore = charsPassed - chars;

        const pageStart = Math.floor(charsBefore / this.charsInPage) + 1;
        const pageEnd = Math.floor(charsPassed / this.charsInPage) + 1;

        if (!this._pageBreak)
            this._pageBreak = pageStart != pageEnd;

        paragraph.dataset.page = pageEnd.toString();

        //  XXX: when the next page/folio is not loaded in the VW2 editions
        //       reader we know nothing about the next paragraph (at this
        //       moment) and this should return null
        // TODO: extract information on/about all paragraphs and send it to the
        //       reader as soon as possible so it doesn’t have to wait or retry
        const nextParagraphInfo = this._nextParagraphInfo(i, paragraph)

        if (!nextParagraphInfo)
            return false; // cannot create the footnotes (yet)

        const charsPassedNext: number = nextParagraphInfo.charsPassedNext;

        if (!this._sectionEnds)
            this._sectionEnds = charsPassedNext < charsPassed;

        this._collectNotes(paragraph);

        if (this._isInTable(paragraph))
            return true;

        if (this._sectionEnds) {
            console.log(
                // edition notes or main text itself
                'TODO: text ends here, emit any remaining footnotes',
                paragraph, nextParagraphInfo.nextParagraph);
        }

        // TODO: avoid placing footnotes under headers though (place them
        //       just above)

        if (this._pageBreak || this._sectionEnds) {
            // paragraph.style.background = 'lightgreen';

            let gotNotes = false;

            for (let noteType in this._notes) {
                if (this._notes[noteType].length) {
                    gotNotes = true;
                    break;
                }
            }

            if (!gotNotes)
                return true;

            // DONE: insert and populate a footnotes container behind this paragraph

            paragraph.insertAdjacentHTML('afterend', '<div class="footnotes-container"></div>');

            const footnotesContainer = paragraph.nextElementSibling;

            for (let noteType of ['bible_reference', 'correction', 'generic']) {
                const notes: Array<HTMLElement> = this._notes[noteType];

                if (!notes || notes.length === 0)
                    continue;

                footnotesContainer.insertAdjacentHTML(
                    'beforeend', `<div class="footnotes footnotes-${noteType}"></div>`);
                const wrapper = footnotesContainer.lastElementChild;

                if (notes.length == 1)
                    wrapper.classList.add('single-note');

                for (let note of notes) {
                    const inNotesPrefix = 'notes-';
                    const inNotes = note.id.startsWith(inNotesPrefix);
                    const reference = note.id.substring(
                        5 + // note-
                        (inNotes ? inNotesPrefix.length : 0));
                    const targetId =
                        (inNotes ? inNotesPrefix : '') + 'footnote-' + reference;

                    wrapper.insertAdjacentHTML(
                        'beforeend',
                        `<div class="footnote">
                                <div class="note-ref-container">
                                <a href="#${note.id}" id="${targetId}">
                                    <sup class="note-ref">${reference}</sup></a>
                                </div>
                                <p></p>
                            </div>`);

                    const footnote = wrapper.lastElementChild.lastElementChild;

                    const noteHtml = this.getNoteHtml(note);
                    footnote.insertAdjacentHTML('beforeend', noteHtml);
                }

                this._notes[noteType] = [];
            }
        }

        this._pageBreak = false;
        this._sectionEnds = false;
        return true;
    }

    _skipTableCellWithParagraphs(paragraph: HTMLElement) : boolean
    {
        if (paragraph.tagName != 'TD')
            return false;

        const paragraphs: NodeListOf<HTMLElement> = paragraph.querySelectorAll(
            '[data-paragraph-number]');

        return paragraphs.length > 0;
    }

    _collectNotes(paragraph: HTMLElement)
    {
        const notes: NodeListOf<HTMLElement> = paragraph.querySelectorAll(
            'a[id^="note-"], a[id^="notes-note-"]');

        for (let i = 0; i < notes.length; i++) {
            let note = notes[i];

            const reference = note.id.substring(5); // note-
            const number = Number.parseInt(reference);

            // “generic” = “regular + transliterations” apparatus
            let noteType = Number.isNaN(number) ? 'correction' : 'generic';

            if (note.dataset.type == 'correction' && noteType != 'correction')
                noteType = note.dataset.type;

            // TODO: trust this attribute and only fall back to the legacy detection
            //       if it isn’t present
            if (note.dataset.type == 'bible_reference')
                noteType = note.dataset.type;

            if (!(noteType in this._notes))
                this._notes[noteType] = [];

            this._notes[noteType].push(note);
        }
    }

    // modeled after _getCounterpartIds
    _isInTable(paragraph: HTMLElement) : boolean
    {
        let node = paragraph;

        for (let _limit = 4; _limit > 0; _limit--) {
            if (!node)
                break;

            if (node.tagName == 'TD')
                return true;

            node = node.parentElement;
        }

        return false;
    }

    linkNotesToLemmas()
    {
        const paragraphs: NodeListOf<HTMLElement> = this.root.querySelectorAll(
            '[data-paragraph-number]');

        for (let i = 0; i < paragraphs.length; i++) {
            let paragraph = paragraphs[i];

            let notes: NodeListOf<HTMLElement> = paragraph.querySelectorAll(
                'a[id^="note-"], a[id^="notes-note-"]');

            for (let j = 0; j < notes.length; j++) {
                let note = notes[j];
                this._linkNoteToLemmaParts(note);
            }
        }
    }

    _linkNoteToLemmaParts(note: HTMLElement)
    {
        const attr = note.dataset.lemmaParts;
        if (!attr)
            return;

        const lemmaPartIds = attr.split(' ');

        for (let lemmaPartId of lemmaPartIds) {
            let lemmaPart: HTMLElement = null;

            try {
                // FIXME: DOMException: '#118' is not a valid selector
                document.querySelector(lemmaPartId);

            } catch (e) {
                console.error(lemmaPartId, e);
            }

            if (lemmaPart === null)
                continue;

            this._addEventListenersToItem(lemmaPart, 'lemmaPart');
        }

        this._addEventListenersToItem(note, 'note');
    }

    _addEventListenersToItem(item: HTMLElement, itemType: string)
    {
        const attrsAndClasses = this._attrsAndClasses[itemType];

        for (let eventName of ['mouseover', 'mouseout']) {
            let listeners = this._eventListeners[eventName];

            if (item.id in listeners)
                continue;

            // TODO: also highlight other non-shared parts of a lemma when hovering
            //       over a non-shared part (and … either ignore shared parts (e.g.
            //       in midst of the non-shared parts) or perhaps highlight that too??)

            let listener = (_event: MouseEvent) =>
            {
                const counterpartIds = this._getCounterpartIds(
                    item, attrsAndClasses.counterpartsAttr);

                for (let i = 0; i < counterpartIds.length; i++) {
                    // This is a note when an item is a part of a lemma and vice versa.
                    let counterpart: HTMLElement = document.querySelector(counterpartIds[i]);

                    if (!counterpart)
                        continue;

                    /* XXX: a:hover won’t be triggered!
                    https://stackoverflow.com/questions/17226676/how-do-i-simulate-a-mouseover-in-pure-javascript-that-activates-the-css-hover
                    counterpart.dispatchEvent(new MouseEvent(eventName,
                    {
                        view: window,
                        bubbles: true,
                        cancelable: true,
                    }));
                    */

                    const cls = attrsAndClasses.counterpartsHoverClass;

                    if (eventName == 'mouseover')
                        counterpart.classList.add(cls);

                    else
                        counterpart.classList.remove(cls);
                }
            };

            item.addEventListener(eventName, listener);
            listeners[item.id] = listener;
        }
    }

    _getCounterpartIds(item: HTMLElement, counterpartsAttr: string) : Array<string>
    {
        let node = item;

        for (let _limit = 3; _limit > 0; _limit--) {
            if (!node)
                break;

            let attr = node.dataset[counterpartsAttr];

            if (!attr) {
                node = node.parentElement;
                continue;
            }

            return attr.split(' ');
        }

        return [];
    }
}


class VW2EditionsViewer extends EditionsViewer
{
    getNoteHtml(note: HTMLElement): string
    {
        return note.nextElementSibling.innerHTML;
    }
}


export default EditionsViewer;
export { VW2EditionsViewer };
